module.exports = __webpack_public_path__ + "img/anemone.c86ca4c8.jpg";